import { IntlShape } from "react-intl";

export const unitMeasurementCmOrInch = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.inch",
      defaultMessage: "Inch",
    }),
    is_active: false,
    value: "inch",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.cm",
      defaultMessage: "Cm",
    }),
    is_active: false,
    value: "cm",
  },
];

export const unitMeasurementKgOrLbs = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.unitOfMeasurementOption1",
      defaultMessage: "lbs",
    }),
    is_active: false,
    value: "lbs",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.unitOfMeasurementOption2",
      defaultMessage: "kg",
    }),
    is_active: false,
    value: "kg",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.unitOfMeasurementOption3",
      defaultMessage: "Total lbs",
    }),
    is_active: false,
    value: "total_lbs",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.unitOfMeasurementOption4",
      defaultMessage: "Total kg",
    }),
    is_active: false,
    value: "total_kg",
  },
];

export const temperatureControlledOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.temperatureControlledOption1",
      defaultMessage: "Deep frozen: <-20°C (4°F)",
    }),
    is_active: false,
    value: "1",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.temperatureControlledOption2",
      defaultMessage: "Store frozen: -20°C (4°F)",
    }),
    is_active: false,
    value: "2",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.temperatureControlledOption3",
      defaultMessage: "Store at 2°- 8°C (36°- 46°F)",
    }),
    is_active: false,
    value: "3",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.temperatureControlledOption4",
      defaultMessage: "Cool: Store between 8°- 15°C (45°- 59°F)",
    }),
    is_active: false,
    value: "4",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.temperatureControlledOption5",
      defaultMessage: "Room temperature: Store at 15°- 25°C (59°- 77°F)",
    }),
    is_active: false,
    value: "5",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.temperatureControlledOption6",
      defaultMessage: "Other",
    }),
    is_active: false,
    value: "6",
  },
];

export const dangerousGoodsOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption1",
      defaultMessage: "1. Explosive substances and articles",
    }),
    is_active: false,
    value: "1",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption2",
      defaultMessage: "2. Gasses",
    }),
    is_active: false,
    value: "2",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption3",
      defaultMessage: "3. Flammable liquids",
    }),
    is_active: false,
    value: "3",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption4",
      defaultMessage: "4. Flammable solids",
    }),
    is_active: false,
    value: "4",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption5",
      defaultMessage: "5. Oxidising substances",
    }),
    is_active: false,
    value: "5",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption6",
      defaultMessage: "6. Toxic & Infectious substances",
    }),
    is_active: false,
    value: "6",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption7",
      defaultMessage: "7. Radioactive material",
    }),
    is_active: false,
    value: "7",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption8",
      defaultMessage: "8. Corrosives",
    }),
    is_active: false,
    value: "8",
  },
  {
    label: intl.formatMessage({
      id: "new-request.packing-list.dangerousGoodsOption9",
      defaultMessage: "9. Miscellaneous",
    }),
    is_active: false,
    value: "9",
  },
];

export const cbmScopeOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "new-request.packing-list.aPiece", defaultMessage: "A piece" }),
    value: "piece",
  },
  {
    label: intl.formatMessage({ id: "quote-request-detail.total", defaultMessage: "Total" }),
    value: "total",
  },
];
